import gql from "graphql-tag";

// The Add New PO picker's own slice of getMyAppointments, so `isWithdrawn` never rides on the schedule's query.
export const GET_MY_PART_ORDER_JOBS = gql`
  query getMyPartOrderJobs($startRange: Date!, $endRange: Date!) {
    getMyAppointments(startRange: $startRange, endRange: $endRange) {
      id
      job {
        id
        jobNumber
        isWithdrawn
        contact {
          id
        }
        vehicleInfo {
          year
          make
          model
        }
      }
    }
  }
`;
